<template>
  <div class="list-activity-types-container">
    <md-card>
      <i
        class="far fa-chevron-left slide-arrow"
        @click="swipeLeft"
      />
      <div
        id="content"
        ref="content"
        class="scrollable"
      >
        <div
          v-for="activity in activityTypes"
          :key="activity.number"
          :class="{'card-content': true, 'selected': selectedActivities.includes(activity.number)}"
          @click="selectActivity(activity.number)"
        >
          <i :class="formatActitivityIcon(activity.number)" />
          <span>{{ activity.label }}</span>
        </div>
      </div>
      <i
        class="far fa-chevron-right slide-arrow"
        @click="swipeRight"
      />
    </md-card>
  </div>
</template>

<script>
import activity from "@/utils/activity";

export default {
  name: 'ListActivityTypes',
  data() {
    return {
      activityTypes: activity.getActivitiesWithValidData(),
      selectedActivities: [],
    }
  },
  methods: {
    ...activity,
    selectActivity(activityId) {

      const hasActivity = this.selectedActivities.includes(activityId);
      if (hasActivity) {
        this.selectedActivities = this.selectedActivities.filter(f => f !== activityId)
      } else {
        this.selectedActivities.push(activityId)
      }
      this.$emit('selectedActivityChanged', this.selectedActivities);

    },
    scrollTo(element, scrollPixels, duration) {
      const scrollPos = element.scrollLeft;
      if (!((scrollPos === 0 || scrollPixels > 0)
          && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
        const startTime =
            "now" in window.performance
                ? performance.now()
                : new Date().getTime();

        function scroll(timestamp) {
          const timeElapsed = timestamp - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          element.scrollLeft = scrollPos + scrollPixels * progress;
          if (timeElapsed < duration) {
            window.requestAnimationFrame(scroll);
          } else {
            return;
          }
        }
        window.requestAnimationFrame(scroll);
      }
    },
    swipeLeft() {
      const content = this.$refs.content;
      this.scrollTo(content, -300, 800);
    },
    swipeRight() {
      const content = this.$refs.content;
      this.scrollTo(content, 300, 800);
    }
  }
}
</script>

<style lang="scss">
.list-activity-types-container {
  display: flex;
  align-items: center;
  margin-right: 10px;
  height: 48px;
  .md-card {
    display: flex;
    flex-direction: unset;
    height: 100%;
    padding: 8px 12px;
    align-items: center;

    .slide-arrow {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &:hover {
        background: gray;
        color: white;
        border-radius: 50%;
      }
    }
    .scrollable {
      display: flex;
      overflow: hidden;
      margin: 0 15px;
      height: 100%;
      flex-wrap: inherit;
    }
    .card-content {
      display: flex;
      border: 1px solid #E0D8D8;
      margin-right: 10px;
      border-radius: 6px;
      align-items: center;
      padding: 0 10px;
      cursor: pointer;
      height: 32px;
      &.selected {
        background: #DF263B;
        color: white;
      }
      &:hover {
        background: #DF263B;
        color: white;
      }
      i {
        margin-right: 8px;
      }
      span {
        white-space: nowrap;
        font-weight: 400;
        font-size: 14px;
      }
    }
  }
}
</style>
